import {
  Checkbox,
  Grid,
  List,
  ListItemText,
  styled,
  Box,
  ListItemIcon,
  ListItem,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { amplitude } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import { useWorkspaceContext } from '../../../../../../../src/context';
import { ActivateFeature } from '../../../../../../components/ActivateFeature';
import useJob from '../../../../../../features/jobs/hooks/useJob';
import JobPageParams from '../../../../types/JobPageParams';

export interface IJobBoard {
  name: string;
  icon?: React.ReactElement;
  label?: string;
  url?: string;
}

export interface IFreeJobBoardProps {
  jobBoards: IJobBoard[];
  selectedJobBoards: (jobBoardNames: string[]) => void;
  setSelectAll: (arg: boolean) => void;
  checkedEl: string[];
}

const StyledListItem = styled(ListItem)({
  '&:hover': {
    background: WsColors.TheBlues50,
  },
});

const FreeJobBoardCard = ({
  jobBoards,
  setSelectAll,
  selectedJobBoards,
  checkedEl = [],
}: IFreeJobBoardProps) => {
  const [checked, setChecked] = useState<string[]>([]);
  const workspace = useWorkspaceContext();
  const params = useParams<JobPageParams>();
  const jobId = params.jobId;
  const [jobDetails] = useJob(jobId ?? '');
  const postedOnJobBoardsList = jobDetails?.postedOnJobBoards;

  const handleToggle = (label: string) => () => {
    amplitude('Job_publish_freejobboards', {
      clickedOn: 'Any individual job boards',
      pageName: 'Publish jobs',
      pageUrl: window.location.href,
      workspaceName: workspace.name,
      planType: workspace.planType,
      interfaceType: 'Web',
    });
    const currentIndex = checked.indexOf(label);

    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(label);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);

    selectedJobBoards(newChecked);
  };

  useEffect(() => setChecked(checkedEl), [checkedEl, setSelectAll]);

  return (
    <Grid>
      {jobBoards
        .filter((item) => item.label != 'CareersPage')
        .map((jobBoard: IJobBoard, index: number) => (
          <List key={index}>
            <Box>
              <StyledListItem>
                <ListItemIcon>{jobBoard.icon}</ListItemIcon>
                <ListItemText primary={jobBoard.name} />
                <Checkbox
                  onChange={handleToggle(jobBoard.label ?? '')}
                  checked={
                    postedOnJobBoardsList?.includes(jobBoard.label ?? '') ||
                    checked.indexOf(jobBoard.label ?? '') !== -1
                  }
                />
              </StyledListItem>
            </Box>
          </List>
        ))}
      <ActivateFeature feature="CP_POST_JOB_TO_CAREER_PAGES">
        {jobBoards
          .filter((item) => item.label === 'CareersPage')
          .map((jobBoard: IJobBoard, index: number) => (
            <List key={index}>
              <Box>
                <StyledListItem>
                  <ListItemIcon>{jobBoard.icon}</ListItemIcon>
                  <ListItemText primary={jobBoard.name} />
                  <Checkbox
                    onChange={handleToggle(jobBoard.label ?? '')}
                    checked={
                      postedOnJobBoardsList?.includes(jobBoard.label ?? '') ||
                      checked.indexOf(jobBoard.label ?? '') !== -1
                    }
                  />
                </StyledListItem>
              </Box>
            </List>
          ))}
      </ActivateFeature>
    </Grid>
  );
};

export default FreeJobBoardCard;
